export enum EventStatus {
  Success = 'success',
  Processing = 'processing',
  Error = 'error',
  Warning = 'warning'
}
